import React from 'react'
import {connect} from 'react-redux'

import {
  VIEWPORT_TYPES
} from './config/constants'

const {PHONE} = VIEWPORT_TYPES

import showModal from './data/actions/show_modal'

class GroupChatSubscribeButton extends React.Component {
  constructor (props) {
    super(props)

    this.state = {}

    this.blur = this.blur.bind(this)
    this.focus = this.focus.bind(this)
    this.openSubscriptionModal = this.openSubscriptionModal.bind(this)
  }

  blur () {
    this.setState({isFocused: false})
  }

  focus () {
    this.setState({isFocused: true})
  }

  openSubscriptionModal (e) {
    if (e && e.preventDefault) e.preventDefault()
    this.setState({isFocused: false})

    const {uid, groupId, source} = this.props
    this.props.showModal({type: 'groupSubscribe', identifier: 'group-chat-subscription-modal', props: {uid, groupId, source}})
  }

  renderLabel (text) {
    if (this.props.shouldShowLabels && this.props.viewportType !== PHONE) {
      return (
        <span style={{verticalAlign: 'middle'}}>{text}</span>
      )
    }
  }

  renderSubscribedButton () {
    const width = this.props.shouldShowLabels && this.props.viewportType !== PHONE ? this.props.width : 'auto'
    const marginRight = this.props.shouldShowLabels && this.props.viewportType !== PHONE ? 4 : null

    if (this.state.isFocused) {
      return (
        <a href='#' title='Change Subscription for Email Notifications' className='btn btn-warning btn-sm' onMouseLeave={this.blur} onClick={this.openSubscriptionModal}>
          <div style={{width, textAlign: 'left'}}>
            <i className='rc-icon-subscribe' style={{marginRight, verticalAlign: 'middle', fontSize: 16}}/>
            {this.renderLabel('Change')}
          </div>
        </a>
      )
    }
    else {
      return (
        <a href='#' className='btn btn-success btn-sm' onMouseEnter={this.focus} onTouchEnd={this.openSubscriptionModal}>
          <div style={{width, textAlign: 'left'}}>
            <i className='rc-icon-subscribe' style={{marginRight, verticalAlign: 'middle', fontSize: 16}}/>
            {this.renderLabel('Notifications')}
          </div>
        </a>
      )
    }
  }

  renderUnSubscribedButton () {
    const width = this.props.shouldShowLabels && this.props.viewportType !== PHONE ? this.props.width : 'auto'
    const marginRight = this.props.shouldShowLabels && this.props.viewportType !== PHONE ? 4 : null

    return (
      <a href='#' title='Subscribe for Email Notifications' className='btn btn-success btn-sm btn-stripped' onClick={this.openSubscriptionModal}>
        <div style={{width, textAlign: 'left'}}>
          <i className='rc-icon-subscribe' style={{marginRight, verticalAlign: 'middle', fontSize: 16}}/>
          {this.renderLabel('Notifications')}
        </div>
      </a>
    )
  }

  render () {
    if (!this.props.uid) return false
    if (this.props.subscribedGroup) return this.renderSubscribedButton()

    return this.renderUnSubscribedButton()
  }
}

GroupChatSubscribeButton.defaultProps = {
  width: 90,
  shouldShowLabels: true
}

const mapStateToProps = (state, ownProps) => {
  let uid, subscribedGroup

  if (ownProps.source === 'user') {
    uid = ownProps.uid
    subscribedGroup = state.getIn(['groups', '_subscriptions', 'groups', ownProps.groupId, uid])
  }
  else {
    uid = state.getIn(['currentUser', 'uid'])
    subscribedGroup = state.getIn(['groups', '_subscriptions', 'users', uid, ownProps.groupId])
  }

  return {
    uid,
    subscribedGroup,
    viewportType: state.getIn(['viewport', 'type'])
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    showModal: (modal) => dispatch(showModal(modal))
  }
}

const GroupChatSubscribeButtonContainer = connect(
  mapStateToProps, mapDispatchToProps
)(GroupChatSubscribeButton)

export default GroupChatSubscribeButtonContainer



/** WEBPACK FOOTER **
 ** ./modules/shared/group_chat_subscribe_button.js
 **/